/**
 * getCallDirection
 * @param direction   direction in number
 */
export function getCallDirectionString(direction: number) {}

/**
 * format second to HH | HH:MM:SS
 * @param seconds     seconds in number
 * @param onlyHours   return only hours
 * @returns {string} HH | HH:MM:SS
 */
export function formatDate(seconds: number, onlyHours = false) {
  const hours = Math.trunc(seconds / 3600); // 3,600 seconds in 1 hour

  if (onlyHours) return pad(hours);

  seconds = seconds % 3600; // seconds remaining after extracting hours
  const minutes = Math.trunc(seconds / 60); // 60 seconds in 1 minute
  seconds = Math.trunc(seconds % 60);

  return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  function pad(value: any) {
    return value.toString().padStart(2, '0');
  }
}

/**
 * format second to HH:MM:SS | Total Seconds
 * @param seconds     timeString HH:MM:SS in string
 * @returns {string} HH:MM:SS | Total Seconds
 */
export function convertToSeconds(timeString: string) {
  const [hours, minutes, seconds] = timeString.split(':');
  return Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);
}
